import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { css } from "styled-components";

paginationStyles.pagination = {
    buttonProps: {
        css: css`
            width: auto !important;
            border: none !important;
        `,
    },
    cssOverrides: {
        pagination: css`
            margin: 0 !important;
        `,
        perPageSelect: css`
            label {
                width: auto;
                font-style: italic;
                font-weight: normal;
            }
            width: auto !important;
        `,
        linkList: css`
            width: auto !important;
        `,
    },
};
